
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class BrandLogo extends Vue {
  @Prop({type: String, default: 'default'})
  public variant!: 'default' | 'circle'

  @Prop({type: String, default: '#222'})
  public colorMain!: string

  @Prop({type: String, default: '#f00'})
  public colorAccent!: string

  @Prop({type: String, default: ''})
  public width!: string

  @Prop({type: String, default: ''})
  public height!: string

  private sizing = {
    default: {
      height: '431',
      width: '821'
    },
    circle: {
      height: '690',
      width: '951'
    }
  }

  public get svgWidth() {
    if (this.width) {
      return this.width
    }
    if (this.height) {
      return 'auto'
    }
    return this.sizing[this.variant].width
  }

  public get svgHeight() {
    if (this.height) {
      return this.height
    }
    if (this.width) {
      return 'auto'
    }
    return this.sizing[this.variant].height
  }
}

